
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import WhatsAppButton from '../../../components/feature/WhatsAppButton';
import EcoPilot from '../../../components/feature/EcoPilot';
import { useState } from 'react';
import Button from '../../../components/base/Button';
import Card from '../../../components/base/Card';
import QuoteModal from '../../../components/feature/QuoteModal';

export default function ESGPage() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  return (
    <>
      <Header />
      <main className="min-h-screen">
        {/* Hero Section */}
        <section 
          className="relative py-32 bg-cover bg-center"
          style={{ 
            backgroundImage: 'url(https://readdy.ai/api/search-image?query=ESG%20Environmental%20Social%20Governance%20consulting%20with%20diverse%20business%20professionals%20analyzing%20sustainability%20metrics%20charts%20and%20governance%20frameworks%20in%20modern%20corporate%20office%20environment&width=1200&height=600&seq=607&orientation=landscape)' 
          }}
        >
          <div className="absolute inset-0 bg-green-900/80"></div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl">
              <h1 className="text-5xl font-bold text-white mb-6 animate-in fade-in slide-in-from-bottom-8 duration-1000">
                ESG Danışmanlığı
              </h1>
              <p className="text-xl text-green-100 mb-8 leading-relaxed animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-300">
                Çevresel, Sosyal ve Kurumsal Yönetim kriterlerinde uzman danışmanlık ile sürdürülebilir değer yaratın. Yatırımcıların güvenini kazanın ve riskleri yönetin.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-500">
                <Button 
                  size="lg"
                  onClick={() => setIsQuoteModalOpen(true)}
                  className="whitespace-nowrap"
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-file-text-line"></i>
                  </div>
                  Teklif Al
                </Button>
                <Button 
                  size="lg" 
                  variant="outline"
                  onClick={() => window.open('https://calendly.com/ecoventra', '_blank')}
                  className="border-white text-white hover:bg-white hover:text-green-700 whitespace-nowrap"
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-calendar-line"></i>
                  </div>
                  Ücretsiz Konsültasyon
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* ESG Components */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                ESG Danışmanlık Hizmetlerimiz
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Çevresel, Sosyal ve Yönetişim alanlarında kapsamlı danışmanlık çözümleri
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
              {[
                {
                  title: 'Environmental (Çevresel)',
                  icon: 'ri-leaf-line',
                  color: 'green',
                  items: ['Karbon Ayak İzi', 'Su Yönetimi', 'Atık Yönetimi', 'Enerji Verimliliği', 'Biyoçeşitlilik', 'Dairesel Ekonomi']
                },
                {
                  title: 'Social (Sosyal)',
                  icon: 'ri-team-line',
                  color: 'blue',
                  items: ['İnsan Hakları', 'Çalışan Sağlığı', 'Toplumsal Katkı', 'Müşteri Memnuniyeti', 'Tedarik Zinciri', 'Çeşitlilik & Kapsayıcılık']
                },
                {
                  title: 'Governance (Yönetişim)',
                  icon: 'ri-shield-star-line',
                  color: 'purple',
                  items: ['Kurumsal Yönetim', 'Etik ve Uyumluluk', 'Risk Yönetimi', 'Şeffaflık', 'Yönetim Kurulu', 'Paydaş İlişkileri']
                }
              ].map((component, index) => (
                <Card key={index} className="p-8 hover:shadow-xl transition-all duration-300 hover:scale-105">
                  <div className={`w-16 h-16 bg-${component.color}-100 rounded-full flex items-center justify-center mx-auto mb-6`}>
                    <i className={`${component.icon} text-3xl text-${component.color}-600`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">{component.title}</h3>
                  <div className="space-y-3">
                    {component.items.map((item, itemIndex) => (
                      <div key={itemIndex} className="flex items-center text-gray-700">
                        <i className={`ri-check-line text-${component.color}-500 mr-3`}></i>
                        <span className="text-sm">{item}</span>
                      </div>
                    ))}
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </section>

        {/* Process */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                ESG Danışmanlık Sürecimiz
              </h2>
              <p className="text-xl text-gray-600">
                8-12 haftalık kapsamlı ESG stratejisi geliştirme
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                {
                  step: '1',
                  title: 'ESG Değerlendirmesi',
                  description: 'Mevcut ESG performansının kapsamlı analizi',
                  duration: '2-3 hafta'
                },
                {
                  step: '2',
                  title: 'Risk ve Fırsat Analizi',
                  description: 'ESG risklerinin ve fırsatlarının identificasyonu',
                  duration: '2-3 hafta'
                },
                {
                  step: '3',
                  title: 'Strateji Geliştirme',
                  description: 'ESG hedefleri ve eylem planının oluşturulması',
                  duration: '2-3 hafta'
                },
                {
                  step: '4',
                  title: 'Uygulama ve İzleme',
                  description: 'ESG stratejisinin uygulanması ve performans izleme',
                  duration: '2-3 hafta'
                }
              ].map((process, index) => (
                <div key={index} className="relative">
                  <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                    <div className="flex items-center mb-4">
                      <div className="w-12 h-12 bg-green-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4">
                        {process.step}
                      </div>
                      <div className="text-sm text-green-600 font-medium">{process.duration}</div>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">{process.title}</h3>
                    <p className="text-gray-600 text-sm">{process.description}</p>
                  </div>
                  {index < 3 && (
                    <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                      <i className="ri-arrow-right-line text-2xl text-green-300"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-6">
                  ESG Danışmanlığının Faydaları
                </h2>
                <div className="space-y-6">
                  {[
                    {
                      icon: 'ri-funds-line',
                      title: 'Yatırım Çekme',
                      description: 'ESG odaklı yatırımcılar için cazip yatırım fırsatı yaratma'
                    },
                    {
                      icon: 'ri-shield-line',
                      title: 'Risk Azaltma',
                      description: 'Çevresel, sosyal ve yönetişim risklerinin proaktif yönetimi'
                    },
                    {
                      icon: 'ri-speed-up-line',
                      title: 'Operasyonel Verimlilik',
                      description: 'Sürdürülebilir operasyonlarla maliyet tasarrufu'
                    },
                    {
                      icon: 'ri-trophy-line',
                      title: 'Marka İtibarı',
                      description: 'Güçlü ESG performansı ile marka değeri artışı'
                    }
                  ].map((benefit, index) => (
                    <div key={index} className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className={`${benefit.icon} text-xl text-green-600`}></i>
                      </div>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-1">{benefit.title}</h3>
                        <p className="text-gray-600">{benefit.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=Business%20professionals%20celebrating%20ESG%20success%20with%20environmental%20social%20governance%20achievements%2C%20investment%20growth%20charts%20and%20sustainability%20awards%20in%20modern%20corporate%20office&width=600&height=400&seq=608&orientation=landscape"
                  alt="ESG Danışmanlık Faydaları"
                  className="rounded-2xl shadow-2xl"
                />
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-green-600">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              ESG Danışmanlığınız İçin Başlayın
            </h2>
            <p className="text-xl text-green-100 mb-10">
              Sürdürülebilir değer yaratmak için uzman desteği alın
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                size="lg"
                onClick={() => setIsQuoteModalOpen(true)}
                className="bg-white text-green-600 hover:bg-gray-100 whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-file-text-line"></i>
                </div>
                Detaylı Teklif Al
              </Button>
              <Button 
                size="lg" 
                variant="outline"
                onClick={() => window.open('https://api.whatsapp.com/send?phone=905326230183&text=Merhaba, ESG danışmanlığı hakkında bilgi almak istiyorum.', '_blank')}
                className="border-white text-white hover:bg-white hover:text-green-600 whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-whatsapp-line"></i>
                </div>
                WhatsApp ile İletişim
              </Button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
      <EcoPilot />
      
      <QuoteModal 
        isOpen={isQuoteModalOpen} 
        onClose={() => setIsQuoteModalOpen(false)} 
      />
    </>
  );
}
